import { useCallback, useEffect } from 'react';

function useEnterToSubmit(onSubmit: () => void) {
  const handleKeyPress = useCallback(
    (event) => {
      if (event.key === 'Enter') onSubmit();
    },
    [onSubmit]
  );

  useEffect(() => {
    window.addEventListener('keyup', handleKeyPress);
    return () => window.removeEventListener('keyup', handleKeyPress);
  }, [handleKeyPress]);

  return { handleKeyPress };
}

export default useEnterToSubmit;
